import { post } from '@/libs/http';
import { ThirdLoginReq, ThirdLoginRes } from "@/types/api/user-auth/third-login.d";
import { createApiMutationHook } from '@/hooks/use-api-mutation';
import { ThirdLoginType, LoginStatusType } from '@/const/login';

export interface CustomThirdLoginRes extends Omit<ThirdLoginRes, 'loginStatus'> {
  loginStatus?: LoginStatusType;
}

export const postThirdLogin = ({
  params,
}: {
  params: Omit<ThirdLoginReq, 'loginType'> & {
    loginType: (typeof ThirdLoginType)[keyof typeof ThirdLoginType];
  };
}) => {
  return post<CustomThirdLoginRes>('/user/auth/v1/third/login', params);
};

export const usePostThirdLogin = createApiMutationHook(postThirdLogin);